import { Action } from "redux";

export enum AuthenticationAction {
    LOGIN = "@@authentication/LOGIN",
    LOGIN_ERROR = "@@authentication/LOGIN_ERROR",
    LOGIN_SUCCESS = "@@authentication/LOGIN_SUCCESS",
    LOGOUT = "@@authentication/LOGOUT",
    SET_USER = "@@authentication/SET_USER",
    SETUP_APP = "@@authentication/SETUP_APP"
}

export type IAuthenticationAction =
    ILoginAction |
    ILoginErrorAction |
    ILoginSuccessAction |
    ILogoutAction |
    ISetUserAction;

export interface ILoginAction extends Action<AuthenticationAction.LOGIN> {
    username?: string;
    password?: string;
    rememberMe?: boolean;
}

export type ILogoutAction = Action<AuthenticationAction.LOGOUT>;
export type ILoginErrorAction = Action<AuthenticationAction.LOGIN_ERROR>;
export type ILoginSuccessAction = Action<AuthenticationAction.LOGIN_SUCCESS>;

export interface ISetUserAction extends Action<AuthenticationAction.SET_USER> {
    user: any;
}

export interface ISetupAction extends Action<AuthenticationAction.SETUP_APP> {
    path?: string;
}

export const login = (username?: string, password?: string, rememberMe?: boolean): ILoginAction => ({
    type: AuthenticationAction.LOGIN,
    username,
    password,
    rememberMe,
});

export const setUser = (user: any): ISetUserAction => ({
    type: AuthenticationAction.SET_USER,
    user,
});

export const setupApp = (path?: string): ISetupAction => ({
    type: AuthenticationAction.SETUP_APP,
    path
});

export function loginSuccess(): ILoginSuccessAction {
    return { type: AuthenticationAction.LOGIN_SUCCESS };
}

export function loginError(): ILoginErrorAction {
    return { type: AuthenticationAction.LOGIN_ERROR };
}

export function logout(): ILogoutAction {
    return { type: AuthenticationAction.LOGOUT };
}

